module.exports = __webpack_public_path__ + "img/sleeve length.17c33ac8.png";